// extracted by mini-css-extract-plugin
export default {"footer-container":"FooterComponent_footer-container__ACFP6","footer-sub-container":"FooterComponent_footer-sub-container__udIlt","footer-text":"FooterComponent_footer-text__beLAL"};